export default "__VITE_ASSET__EySyKtZl__"